import { render, staticRenderFns } from "./devisList.vue?vue&type=template&id=35d6be16&scoped=true"
import script from "./devisList.vue?vue&type=script&lang=js"
export * from "./devisList.vue?vue&type=script&lang=js"
import style0 from "./devisList.vue?vue&type=style&index=0&id=35d6be16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d6be16",
  null
  
)

export default component.exports